import { FilterFormValues, FilterItem, FilterMode, FilterSaveRequest, OnDemandFilterFormValues } from "./filterTypes";

const pickIdIfPossible = (value: unknown) => {
	if (value !== null && typeof value === "object" && "id" in value) {
		return value.id;
	} else {
		return value;
	}
};

const mapValue = (value: unknown) => {
	if (Array.isArray(value)) {
		return value.map(pickIdIfPossible);
	} else {
		return pickIdIfPossible(value);
	}
};
export const mapFilterToRequest = (filter: FilterFormValues) => {
	const filterItems =
		filter.mode === FilterMode.QUICK
			? filter.filterItems.filter(({ value }) => value !== null && value.length > 0)
			: filter.filterItems;

	return {
		...filter,
		filterItems: filterItems.map((item) => ({
			field: item.field,
			operator: item.operator,
			value: mapValue(item.value),
		})),
	} as FilterSaveRequest;
};

export const emptyQuickFilterItems: FilterItem[] = [
	{
		entity: "EVENT",
		field: "EVENT_TYPE",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "EVENT_CATEGORY",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "FORMAT",
		operators: ["IN"],
		operator: "IN",
		value: [],
	},
	{
		entity: "EVENT",
		field: "START",
		operators: ["GREATER_THAN_EQUAL"],
		operator: "GREATER_THAN_EQUAL",
		value: null,
	},
	{
		entity: "EVENT",
		field: "END",
		operators: ["LESS_THAN_EQUAL"],
		operator: "LESS_THAN_EQUAL",
		value: null,
	},
	{
		entity: "EVENT",
		field: "INDUSTRIES",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "REGION",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "PRIMARY_ORGANIZATIONAL_UNIT",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "ORGANIZATIONAL_UNITS",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "TAGS",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "TARGET_GROUP",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "LOCATION",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
	{
		entity: "EVENT",
		field: "ORGANIZER",
		operators: ["IN_RELATION"],
		operator: "IN_RELATION",
		value: [],
	},
];

export const emptyQuickFilter: OnDemandFilterFormValues = {
	mode: FilterMode.QUICK,
	filterItems: emptyQuickFilterItems,
};

export const emptyAdvancedFilter: OnDemandFilterFormValues = {
	mode: FilterMode.ADVANCED,
	filterItems: [],
};
